import dynamicAPI from '../dynamicAPI';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useMessage } from '../../context/AdminMessageContext';

const base = '/api/auth/invites';

export default function useAdminUserInvitesHook({ page = 1, limit = 25 } = {}) {
    const queryClient = useQueryClient();
    const { setSuccessMessage, setErrorMessage } = useMessage();

    // LIST (admin)
    const listInvites = useQuery(
        ['invites', page, limit],
        async () => {
            const res = await dynamicAPI('get', `${base}?page=${page}&limit=${limit}`);
            if (res?.error) throw new Error(res.error);
            return res;
        },
        { retry: 0, enabled: !!page }
    );

    // CREATE (admin)
    const createInvite = useMutation(
        async ({ email, hours }) => await dynamicAPI('post', base, { email, hours }),
        {
            retry: 0,
            onSuccess: () => {
                queryClient.invalidateQueries(['invites']);
                setSuccessMessage('Invite created.');
            },
            onError: (error) => setErrorMessage(error?.error || 'Failed to create invite.'),
        }
    );

    // DELETE (admin)
    const deleteInvite = useMutation(
        async (id) => await dynamicAPI('delete', `${base}/${id}`),
        {
            retry: 0,
            onSuccess: () => {
                queryClient.invalidateQueries(['invites']);
                setSuccessMessage('Invite deleted.');
            },
            onError: (error) => setErrorMessage(error?.error || 'Failed to delete invite.'),
        }
    );

    // APPROVE (admin)
    const approveInvite = useMutation(
        async (id) => await dynamicAPI('post', `${base}/${id}/approve`),
        {
            retry: 0,
            onSuccess: () => {
                queryClient.invalidateQueries(['invites']);
                setSuccessMessage('User approved.');
            },
            onError: (error) => setErrorMessage(error?.error || 'Approval failed.'),
        }
    );

    // REJECT (admin)
    const rejectInvite = useMutation(
        async (id) => await dynamicAPI('post', `${base}/${id}/reject`),
        {
            retry: 0,
            onSuccess: () => {
                queryClient.invalidateQueries(['invites']);
                setSuccessMessage('Invite rejected.');
            },
            onError: (error) => setErrorMessage(error?.error || 'Rejection failed.'),
        }
    );

    return {
        listInvites,
        createInvite,
        deleteInvite,
        approveInvite,
        rejectInvite,
    };
}
